function SurveyProgressBar({ current, total }) {
  const percent = total > 0 ? Math.round((current / total) * 100) : 0

  return (
    <div className="d-flex flex-stack gap-2 mb-3">
      <div className="d-flex flex-column-auto justify-content-end align-items-center">
        <span className="fw-semibold text-dark me-0 fs-7">
          {current} of {total}
        </span>
      </div>
      <div className="h-4px rounded w-100 bg-secondary">
        <div
          className="bg-success rounded h-4px progress-bar-transition"
          role="progressbar"
          style={{ width: `${percent}%` }}
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    </div>
  )
}

export default SurveyProgressBar
